// extracted by mini-css-extract-plugin
export default {"mouseRing":"MouseRing_mouseRing__r0Eze"};